var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-overlay place-content", class: _vm.position },
    [
      _vm.placeSelected
        ? _c("div", { staticClass: "steep1" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "list-item hide-scrollbar" }, [
                _c("div", { staticClass: "item" }, [
                  _c("div", { staticClass: "info" }, [
                    _c("p", { staticClass: "location" }, [
                      _vm._v(_vm._s(_vm.placeSelected.name)),
                    ]),
                    _vm.placeSelected.location
                      ? _c("p", { staticClass: "location-info" }, [
                          _vm._v(
                            _vm._s(
                              _vm.placeSelected.location.street ||
                                _vm.placeSelected.location.city ||
                                _vm.placeSelected.location.country ||
                                _vm.placeSelected.location.zip
                                ? `${_vm.placeSelected.location.street} ${_vm.placeSelected.location.city} ${_vm.placeSelected.location.country} ${_vm.placeSelected.location.zip}`
                                : _vm.placeSelected.name
                            )
                          ),
                        ])
                      : _vm._e(),
                  ]),
                  _c("i", {
                    staticClass: "fa-regular fa-xmark",
                    on: { click: _vm.removePlace },
                  }),
                ]),
              ]),
            ]),
          ])
        : _c("div", { staticClass: "steep2" }, [
            _c("div", { staticClass: "content" }, [
              _c("div", { staticClass: "input" }, [
                _c("i", { staticClass: "fa-regular fa-magnifying-glass" }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.textSearch,
                      expression: "textSearch",
                    },
                  ],
                  attrs: {
                    placeholder: _vm.$t(
                      "dash.post-creator.overlay.search-place"
                    ),
                  },
                  domProps: { value: _vm.textSearch },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.sendSearchPlace.apply(null, arguments)
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.textSearch = $event.target.value
                    },
                  },
                }),
              ]),
              _c(
                "div",
                { staticClass: "list-item hide-scrollbar" },
                [
                  _vm.stateLoader
                    ? _c("span", { staticClass: "loader" })
                    : _vm.listPlacesAvailable.length
                    ? _vm._l(_vm.listPlacesAvailable, function (place, index) {
                        return _c(
                          "div",
                          {
                            key: `location${index}`,
                            staticClass: "item",
                            on: {
                              click: function ($event) {
                                return _vm.selectPlace(place)
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "info" }, [
                              _c("p", { staticClass: "location" }, [
                                _vm._v(_vm._s(place.name)),
                              ]),
                              place.location
                                ? _c("p", { staticClass: "location-info" }, [
                                    _vm._v(
                                      _vm._s(
                                        place.location.street ||
                                          place.location.city ||
                                          place.location.country ||
                                          place.location.zip
                                          ? `${place.location.street || ""} ${
                                              place.location.city || ""
                                            } ${place.location.country || ""} ${
                                              place.location.zip || ""
                                            }`
                                          : place.name
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]
                        )
                      })
                    : _vm.textSearch
                    ? _c("p", { staticClass: "no-result" }, [
                        _vm._v(
                          _vm._s(_vm.$t("dash.post-creator.overlay.no-place"))
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
          ]),
      _c(
        "div",
        {
          staticClass: "btn-secondary",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_vm._v(_vm._s(_vm.$t("dash.button.close")))]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }